export default __webpack_public_path__ + "static/contextMenu-476efe0d6465f0d03863a8159f7db953.gif";